module.exports = __webpack_public_path__ + "media/images/print-df52e2b5856a5a8f2122cad5d1941a39.svg";